import React from 'react';
import { Game } from './components/Game';

export default function App() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <Game />
    </div>
  );
}